import { render, staticRenderFns } from "./LexinKeyboardLangTur.vue?vue&type=template&id=5975d9ed&"
import script from "./LexinKeyboardLangTur.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangTur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports